import AdminSettings from "./views/AdminSettings";
import AdminUsers from "./views/AdminUsers";
import DashboardLayout from "../../layouts/dashboard/DashboardLayout";
import Auth from "../../router/middleware/Auth";
import Admin from "../../router/middleware/Auth";

export default [
  {
    path: "/admin",
    component: DashboardLayout,
    children: [
      {
        path: "",
        redirect: "/admin/settings",
      },
      {
        path: "settings",
        name: "AdminSettings",
        components: {
          view: AdminSettings,
        },
        meta: { middleware: [Auth, Admin] },
      },
      {
        path: "user-settings",
        name: "AdminUsers",
        components: {
          view: AdminUsers,
        },
        meta: { middleware: [Auth, Admin] },
      },
    ],
  },
];
